import type { Query as Query_fqac4i } from '../pages/index.page';
import type { Query as Query_gym8u1 } from '../pages/change-default-password/index.page';
import type { Query as Query_18so8wu } from '../pages/maintenance/index.page';
import type { Query as Query_13m6ngh } from '../pages/recovery/email/index.page';
import type { Query as Query_q2jtqw } from '../pages/recovery/password/index.page';
import type { Query as Query_1qi8uk } from '../pages/recovery/pin/index.page';
import type { Query as Query_eam2li } from '../pages/signout/index.page';
import type { Query as Query_5i3due } from '../pages/user-settings/index.page';
import type { Query as Query_y6s5u1 } from '../pages/user-settings/password/edit/index.page';
import type { Query as Query_oz0mx3 } from '../pages/user-settings/profile/edit/index.page';

export const pagesPath = {
  "$404": {
    $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/404' as const, hash: url?.hash })
  },
  "change_default_password": {
    $url: (url: { query: Query_gym8u1, hash?: string | undefined }) => ({ pathname: '/change-default-password' as const, query: url.query, hash: url.hash })
  },
  "maintenance": {
    $url: (url: { query: Query_18so8wu, hash?: string | undefined }) => ({ pathname: '/maintenance' as const, query: url.query, hash: url.hash })
  },
  "recovery": {
    "email": {
      $url: (url: { query: Query_13m6ngh, hash?: string | undefined }) => ({ pathname: '/recovery/email' as const, query: url.query, hash: url.hash })
    },
    "password": {
      $url: (url: { query: Query_q2jtqw, hash?: string | undefined }) => ({ pathname: '/recovery/password' as const, query: url.query, hash: url.hash })
    },
    "pin": {
      $url: (url: { query: Query_1qi8uk, hash?: string | undefined }) => ({ pathname: '/recovery/pin' as const, query: url.query, hash: url.hash })
    }
  },
  "services": {
    "pharmacy_support_web": {
      "redirect_home": {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/services/pharmacy-support-web/redirect-home' as const, hash: url?.hash })
      }
    }
  },
  "signout": {
    $url: (url: { query: Query_eam2li, hash?: string | undefined }) => ({ pathname: '/signout' as const, query: url.query, hash: url.hash })
  },
  "unauthorized": {
    $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/unauthorized' as const, hash: url?.hash })
  },
  "user_settings": {
    "password": {
      "edit": {
        $url: (url: { query: Query_y6s5u1, hash?: string | undefined }) => ({ pathname: '/user-settings/password/edit' as const, query: url.query, hash: url.hash })
      }
    },
    "profile": {
      "edit": {
        $url: (url: { query: Query_oz0mx3, hash?: string | undefined }) => ({ pathname: '/user-settings/profile/edit' as const, query: url.query, hash: url.hash })
      }
    },
    $url: (url: { query: Query_5i3due, hash?: string | undefined }) => ({ pathname: '/user-settings' as const, query: url.query, hash: url.hash })
  },
  $url: (url: { query: Query_fqac4i, hash?: string | undefined }) => ({ pathname: '/' as const, query: url.query, hash: url.hash })
};

export type PagesPath = typeof pagesPath;
